// extracted by mini-css-extract-plugin
export default {"title":"GridComponent_title__apWkM","description":"GridComponent_description__vbuzD"};